import type { Router } from "vue-router";
import { useSessionStore } from "@/store/session";

export async function stopImpersonating(router: Router): Promise<void> {
    const session = useSessionStore();
    const id = await session.stopImpersonating();
    await router.push(session.authenticated ? { name: "admin-user", params: { id }, query: { impersonation: "stopped" } } : { name: "login" });
}
